import {Component, EventEmitter, Input, OnInit, Output, SimpleChanges} from '@angular/core';
import {FilterGetterListService} from '../../../services/filter-getter-list.service';
import {SINGLE_SELECT_VALUE_TYPES, ValueType} from '../filter.type';

type ItemDropdown = {
    code: string;
    value: string;
};

@Component({
    selector: 'dmp-select',
    templateUrl: './select.component.html',
    styleUrls: ['./select.component.scss'],
    standalone: false
})
export class SelectComponent implements OnInit {
    @Input() tenantCode: string;
    @Input() commandTable!: string;
    @Input() valueType: ValueType;
    @Input() disabled: boolean = false;
    @Input() partner?: string;
    @Input() language: string = 'FR';
    /**
     * Cible de rendu du panneau d'overlay. 'body' par défaut : les conteneurs hôtes
     * (sidebar de configuration, tableaux de filtres) ont un `overflow` qui rognerait
     * un panneau rendu en place.
     */
    @Input() appendTo: any = 'body';

    @Input()
    set ngModelSelect(value: ItemDropdown[] | ItemDropdown) {
        this._ngModelSelect = value;
        // Référence stable : reconstruire le tableau à chaque lecture ferait boucler
        // la détection de changement via [ngModel] (nouvelle référence à chaque cycle).
        this._selectedItems = !value ? [] : (Array.isArray(value) ? value : [value]);
    }

    get ngModelSelect(): ItemDropdown[] | ItemDropdown {
        return this._ngModelSelect;
    }

    @Output() ngModelSelectChange = new EventEmitter();

    currentItem: string;
    filteredItems = [] as ItemDropdown[];

    private _ngModelSelect: ItemDropdown[] | ItemDropdown = [];
    private _selectedItems: ItemDropdown[] = [];

    constructor(private filterGetterListService: FilterGetterListService) {
    }

    get componentType() {
        if (SINGLE_SELECT_VALUE_TYPES.includes(this.valueType)) {
            return 'dropdown';
        } else {
            return 'autocomplete';
        }
    }

    /**
     * p-autoComplete en mode multiple exige un tableau : on tolère un appelant qui
     * fournirait un objet seul ou null (normalisation faite dans le setter d'entrée).
     */
    get selectedItems(): ItemDropdown[] {
        return this._selectedItems;
    }

    ngOnInit(): void {
        this.updateFilteredItems();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.tenantCode || changes.valueType) {
            this.updateFilteredItems();
        }
    }

    updateFilteredItems(): void {
        this.filteredItems = [];
        if (this.componentType === 'dropdown') {
            this.filterGetterListService.getFilterListType(this.tenantCode, this.valueType).then((res) => {
                this.filteredItems = res;
                if (!this.ngModelSelect || (Array.isArray(this.ngModelSelect) && this.ngModelSelect.length === 0)) {
                    this.handleChoice(res[0]);
                }
            });
        }
    }

    handleFilterItems(event) {
        this.filterGetterListService
            .getFilterListType(this.tenantCode, this.valueType, event.query, this.commandTable || undefined, this.partner, this.language)
            .then((res) => {
                this.filteredItems = res;
            });
    }

    handleSelect(event) {
        this.ngModelSelect = [...this.selectedItems, event.value];
        this.ngModelSelectChange.emit(this.ngModelSelect);
    }

    handleUnselect(event) {
        this.ngModelSelect = this.selectedItems.filter(e => e.code !== event.value.code);
        this.ngModelSelectChange.emit(this.ngModelSelect);
    }

    handleChoice(element) {
        this.ngModelSelect = element;
        this.ngModelSelectChange.emit(this.ngModelSelect);
    }
}
